import React, { useState, useEffect } from "react";
import {  useNavigate } from "react-router-dom";
import { Drawer, IconButton } from "@mui/material";
import "./style/sidebar.css";
import { TfiAlignJustify } from "react-icons/tfi";
import { IoMdClose, IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import AOS from "aos";
import "aos/dist/aos.css";
import logosvg from "../../../assets/image/Stellare bijoux logo design-01 (2).svg";

export const DrawerComponent = () => {
  const [leftDrawerOpen, setLeftDrawerOpen] = useState(false);
  const [showProducts, setShowProducts] = useState(false);
  let navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setLeftDrawerOpen((leftDrawerOpen) => leftDrawerOpen);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setLeftDrawerOpen(open);
  };

  const toggleProducts = () => {
    setShowProducts(!showProducts);
  };

  const navigateHome = (e) => {
    e.preventDefault();
    navigate("/");
  };

  const handlenavigate=()=>{
    navigate('/category')
    toggleDrawer(false)
  }
  return (
    <div>
      <div
        onClick={toggleDrawer(true)}
        style={{
          paddingLeft: "10px",
          cursor: "pointer",
          color: 'black',
        }}
        className="text-2xl"
      >
        <TfiAlignJustify />
      </div>
      <Drawer
        anchor="left"
        open={leftDrawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            width: "350px",
          },
        }}
      >
        <div className="flex justify-between p-3">
          <img
            src={logosvg}
            alt="stellare bijoux"
            style={{ objectFit: "cover" }}
            className="Logo"
            id="myIcons"
            onClick={toggleDrawer(false)}
          />
          <IconButton onClick={toggleDrawer(false)}>
            <IoMdClose className="cursor-pointer text-3xl text-gray-400" />
          </IconButton>
        </div>
        {showProducts ? (
          <div className="my-6 mx-0 my-products show-products">
            <ul>
              <li className="my-4 mx-10">
                <p className="flex justify-between IoIosArrowBack">
                  <IoIosArrowBack
                    onClick={() => setShowProducts(false)}
                    className="cursor-pointer"
                  />{" "}
                  Products
                </p>
              </li>
              <hr />
              <li className="my-4 mx-10">
                <p data-aos="fade-right" onClick={handlenavigate}>
                  Ring
                </p>
              </li>
              <hr />
              <li className="my-4 mx-10">
                <p data-aos="fade-right" onClick={handlenavigate}>
                  Earrings
                </p>
              </li>
              <hr />
              <li className="my-4 mx-10">
                <p data-aos="fade-right" onClick={handlenavigate}>
                  Bracelet
                </p>
              </li>
              <hr />
              <li className="my-4 mx-10">
                <p data-aos="fade-right" onClick={handlenavigate}>
                  Necklace
                </p>
              </li>
              <hr />
            </ul>
          </div>
        ) : (
          <div className="my-6 mx-0">
            <ul>
              <li className="my-4 mx-10">
                <a href="/" onClick={navigateHome}>
                  <p data-aos="fade-left">Home</p>
                </a>
              </li>
              <hr />
              <li className="my-4 mx-10" onClick={toggleProducts}>
                <p className="flex justify-between" data-aos="fade-left">
                  Products <IoIosArrowForward className="mt-1 cursor-pointer" />
                </p>
              </li>
              <hr />
              <li className="my-4 mx-10" data-aos="fade-left">
                <a href="/About-us" data-aos="fade-left">
                  About Us
                </a>
              </li>
              <hr />
              <li className="my-4 mx-10" data-aos="fade-left">
                <a href="/Contact-us" data-aos="fade-left">
                  Contact Us
                </a>
              </li>
              <hr />
            </ul>
          </div>
        )}
        <div className="contact_number flex">
          <p>
            <img
              src="//thefoomer.in/cdn/shop/t/47/assets/order-tracking_small.jpg?v=88311329181762376151706097645"
              alt="Tracking Icon"
              className="imgSideBar oneBox"
            />
            <span className="text-xs">
              Track
              <br /> Orders
            </span>
          </p>
          <p>
            <img
              src="//thefoomer.in/cdn/shop/t/47/assets/whatsapp_small.jpg?v=98417115858127822171706097645"
              alt="Whatsapp Icon"
              className="imgSideBar twoBox"
            />
            <span className="text-xs">WhatsApp</span>
          </p>
          <p>
            <img
              src="https://cdn.shopify.com/s/files/1/0687/6171/4968/files/email.png?v=1687943020"
              alt="Mail Icon"
              className="imgSideBar"
            />
            <span className="text-xs">Mail</span>
          </p>
        </div>
      </Drawer>
    </div>
  );
};
